// tsparticles_For_Forum.js

import React, { useCallback } from "react";
import { Particles } from "react-tsparticles";
import { loadFull } from "tsparticles";

const TsparticlesForForum = () => {
  const particlesInit = useCallback(async (engine) => {
    // Initialise la lib avec tous les presets
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    console.log("tsparticles chargé :", container);
  }, []);

  return (
    <Particles
      id="tsparticles_for_forum"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        fpsLimit: 60,
        background: {
          // Si tu veux un background pour *toutes* les particules
          // Sinon tu peux le laisser vide ou supprimer cette section
          // color: { value: "#200211" },
        },
        particles: {
          number: {
            value: 35, // Le nombre de particules en simultané
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: ["#200211", "#D90093", "#FFFFFF"], // Tes couleurs
          },
          shape: {
            type: "images",
            images: [
              { src: "/images/fleurForum_01.png", width: 64, height: 64 },
              { src: "/images/fleurForum_02.png", width: 64, height: 64 },
              { src: "/images/fleurForum_03.png", width: 64, height: 64 },
              { src: "/images/fougereForum_01.png", width: 64, height: 64 },
              { src: "/images/fougereForum_02.png", width: 64, height: 64 },
              { src: "/images/fougereForum_03.png", width: 64, height: 64 },
            ],
            animation: {
              enable: true, // Activer l'animation
              speed: 5, // Vitesse de rotation des particules
              sync: true, // Les particules rotent ensemble
            },
          },
          opacity: {
            value: 0.8,
            random: false,
          },
          size: {
            value: { min: 20, max: 24 },
            random: true,
            animation: {
              speed: 4,
              minimumValue: 0.2,
            },
          },
          move: {
            direction: "bottom", // Les particules « tombent » vers le bas
            enable: true,
            outModes: {
              default: "out", // Quand elles sortent de l'écran, elles disparaissent
            },
            speed: 1, // Vitesse de chute
            random: false,
            straight: false, // Elles dérivent un peu
          },
          rotate: {
            value: {
              min: 0,
              max: 360,
            },
            animation: {
              enable: true,
              speed: 5, // Vitesse de rotation
              sync: true, // Les particules rotent ensemble
            },  
          },
          // Pas de lignes entre les particules
          links: {
            enable: false,
          },
        },
        interactivity: {
          events: {
            onHover: {
              enable: true,
              mode: "repulse", // Au survol, les particules s'éloignent du curseur
            },
            onClick: {
              enable: true,
              mode: "push", // Au clic, on « push » des particules supplémentaires
            },
          },
          modes: {
            repulse: {
              distance: 80,
            },
            push: {
              quantity: 4, // Nombre de particules ajoutées au clic
            },
          },
        },
        detectRetina: true,
      }}
    />
  );
};

export default TsparticlesForForum;
